import React, { useEffect } from 'react';
import HomeLayout from 'layouts/HomeLayout';
import { Link } from 'react-router-dom';
import { FaCheckCircle } from 'react-icons/fa';
import { trackLifetimePurchase } from 'utils/tracking';
import './PaymentSuccess.scss';

const PaymentSuccess: React.FC = () => {
  useEffect(() => {
    trackLifetimePurchase();
  }, []);

  return (
    <HomeLayout title="Payment Successful - Sellerdash">
      <div className="payment-success-page">
        <div className="success-card">
          <FaCheckCircle className="success-icon" />
          <h1>Payment Successful!</h1>
          <p className="success-message">
            Thank you for purchasing Sellerdash Lifetime Access. Your account is ready.
          </p>
          <div className="success-details">
            <p>
              We've sent your login credentials to your email address. Please check your inbox (and spam folder) to sign in.
            </p>
            <p>
              If you already had an account, your subscription has been upgraded to Lifetime — just sign in as usual.
            </p>
          </div>
          <Link to="/signin" className="btn-signin">
            Sign In to Your Account
          </Link>
          <p className="support-text">
            Need help? Email us at <a href="mailto:ask@sellerdash.pk">ask@sellerdash.pk</a>
          </p>
        </div>
      </div>
    </HomeLayout>
  );
};

export default PaymentSuccess;
